export const storeName = 'twoFactorAuth';

export { default as TwoFactorAuthPage } from './TwoFactorAuthPage';
export { default as reducer } from './data/reducers';
export { default as saga } from './data/sagas';
